import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=661600de&scoped=true&"
import script from "./InvoiceDetails.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=661600de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661600de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VRow,VTextField,VTooltip})
